import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_ACTIVE_USER_INIT,
});

export const success = data => ({
  type: USER.GET_ACTIVE_USER_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_ACTIVE_USER_FAILURE,
});

const getActiveUser = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getActiveUser(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getActiveUser;
